module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('doc-section', {
    attrs: {
      "id": "form-validator",
      "name": "Form Validator"
    }
  }, [_c('p', [_vm._v("This is not a style component, but a global validation manager.")]), _vm._v(" "), _c('p', [_vm._v("If you need to evaluate if a group of components are valids, you can handle easier with this component.")]), _vm._v(" "), _c('p', [_vm._v("Actually only supported input & select components.")]), _vm._v(" "), _c('p', [_vm._v("In this example, the buttons and tabs are disabled while the inner elements are empty.")]), _vm._v(" "), _c('div', {
    staticClass: "bs-example"
  }, [_c('h4', [_vm._v("Basic Usage:")]), _vm._v(" "), _c('doc-code', [_vm._v("\n      <!-- Using v-model -->\n      <!-- The starting variable value will be ignored. -->\n      <form-validator v-model=\"valid\">\n        ...\n      </form-validator>\n      <!-- Using event isvalid -->\n        <form-validator @isvalid=\"valid = arguments[0]\">...</form-validator>\n        <!-- or -->\n        <form-validator @isvalid=\"validMethod\">\n          <!-- the method receive true or false in the first argument -->\n        </form-validator>\n      <!-- Using events valid and/or invalid -->\n      <form-validator @valid=\"valid.all = true\" @invalid=\"valid.all = false\">\n          ...\n      </form-validator>\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4"
  }, [_c('p', [_c('pre', [_vm._v("Valid user data : " + _vm._s(_vm.valid.user))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4"
  }, [_c('p', [_c('pre', [_vm._v("Valid direction : " + _vm._s(_vm.valid.direction))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4"
  }, [_c('p', [_c('pre', [_vm._v("All valid : " + _vm._s(_vm.valid.all))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form-validator', {
    model: {
      value: (_vm.valid.all),
      callback: function($$v) {
        _vm.valid.all = $$v
      },
      expression: "valid.all"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('tabs', {
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('tab', {
    attrs: {
      "header": "User"
    }
  }, [_c('form-validator', {
    model: {
      value: (_vm.valid.user),
      callback: function($$v) {
        _vm.valid.user = $$v
      },
      expression: "valid.user"
    }
  }, [_c('bs-input', {
    attrs: {
      "label": "User Name",
      "required": ""
    }
  }), _vm._v(" "), _c('bs-input', {
    attrs: {
      "label": "Email",
      "type": "email",
      "required": ""
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.valid.user
    },
    on: {
      "click": function($event) {
        _vm.active = 1
      }
    }
  }, [_vm._v("Continue")])], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Direction",
      "disabled": !_vm.valid.user
    }
  }, [_c('form-validator', {
    model: {
      value: (_vm.valid.direction),
      callback: function($$v) {
        _vm.valid.direction = $$v
      },
      expression: "valid.direction"
    }
  }, [_c('div', {
    staticClass: "form-validator"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Continent")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "required": "",
      "justified": "",
      "options": ['America', 'Europe'],
      "clear-button": ""
    }
  })], 1), _vm._v(" "), _c('bs-input', {
    attrs: {
      "label": "City",
      "type": "text",
      "required": ""
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.valid.all
    }
  }, [_vm._v("Done!!")])], 1)], 1)], 1)])], 1)], 1), _vm._v(" "), _c('doc-code', {
    attrs: {
      "language": "markup"
    }
  }, [_vm._v("\n      <form-validator v-model=\"valid.all\">\n        <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\">\n          <tabs v-model=\"active\">\n            <tab header=\"User\">\n              <form-validator @valid=\"valid.user = true\" @invalid=\"valid.user = false\">\n                <bs-input label=\"User Name\" required></bs-input>\n                <bs-input label=\"Email\" type=\"email\" required></bs-input>\n              </form-validator>\n              <button type=\"button\" class=\"btn btn-primary\" :disabled=\"!valid.user\" @click=\"active = 1\">Continue</button>\n            </tab>\n            <tab header=\"Direction\" :disabled=\"!valid.user\">\n              <form-validator @isvalid=\"valid.direction = arguments[0]\">\n                <div class=\"form-validator\">\n                  <label class=\"control-label\">Continent</label>\n                  <v-select required justified :options=\"['America','Europe']\" clear-button></v-select>\n                </div>\n                <bs-input label=\"City\" type=\"text\" required></bs-input>\n              </form-validator>\n              <button type=\"button\" class=\"btn btn-primary\" :disabled=\"!valid.all\">Done!!</button>\n            </tab>\n          </tabs>\n        </div>\n      </form-validator>\n  ")]), _vm._v(" "), _c('doc-table', [_c('div', [_c('p', [_vm._v("valid")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("Return if all the internal form elements ("), _c('code', [_vm._v("select")]), _vm._v(", "), _c('code', [_vm._v("input")]), _vm._v(") are valids.")])])])], 1)
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4cfaba24", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4cfaba24!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/example/formValidatorDocs.vue
// module id = 209
// module chunks = 0